export interface PermitLogsDto {
    permitLogs: LogDto[];
}

export interface LogDto {
    currentPersonFullName: string,
    currentPersonRole: number,
    targetPersonFullName: string,
    targetPersonRole: number,
    permitLogEntryType: PermitLogEntryType,
    createdDate: string,
    isExtern: boolean
}

export enum PermitLogEntryType
{
    SignedPermitBeforeStart = 1,
    SignedPermitDuringOngoingPermit = 2,
    SignedPermitAsPostWatchPeriodAtPermitEnd = 3,
    SignedPermitAtPermitEnd = 4,
    AddedPhotoBeforeStart = 5,
    AddedPhotoDuringOngoingPermit = 6,
    AddedCommentDuringOngoingPermit = 7,
    AddedPhotoAtPermitEnd = 8,
    RemovedPhoto = 9,
    RemovedComment = 10,
    AddedCommentAtPermitEnd = 11,
    InquiredForTransferOfPermit = 12,
    ApprovedTransferOfPermit = 13,
    CanceledTransferOfPermit = 14,
    ClosedPermit = 15,
    StartedPermit = 16,
    ExportedPermit = 17,
    MailedPermit = 18,
    ExtendedPermit = 19,
    AddedHotWorkerFireWatchOrFireWatchPostWatch = 20,
    NotificationsToStartPermitWasSent = 21,
    NotificationsThatPermitsEndInOneHourWasSent = 22,
    NotificationsThatPermitsEndedWasSent = 23,
    NotificationsReminderToWriteOffPermitSent = 24,
    SentNotificationForTransferOfPermit = 25,
}
